var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1528_26740",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1528_26740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.3077 21.4999C5.80898 21.4999 5.38302 21.3233 5.02982 20.9701C4.67661 20.6169 4.5 20.1909 4.5 19.6922V10.3076C4.5 9.80893 4.67661 9.38297 5.02982 9.02977C5.38302 8.67656 5.80898 8.49995 6.3077 8.49995H7.5V6.49995C7.5 5.25125 7.93782 4.18908 8.81345 3.31345C9.6891 2.43782 10.7513 2 12 2C13.2487 2 14.3108 2.43782 15.1865 3.31345C16.0621 4.18908 16.5 5.25125 16.5 6.49995V8.49995H17.6922C18.191 8.49995 18.6169 8.67656 18.9701 9.02977C19.3233 9.38297 19.5 9.80893 19.5 10.3076V19.6922C19.5 20.1909 19.3233 20.6169 18.9701 20.9701C18.6169 21.3233 18.191 21.4999 17.6922 21.4999H6.3077ZM6.3077 19.9999H17.6922C17.782 19.9999 17.8557 19.9711 17.9134 19.9134C17.9711 19.8557 18 19.7819 18 19.6922V10.3076C18 10.2179 17.9711 10.1442 17.9134 10.0865C17.8557 10.0288 17.782 9.99993 17.6922 9.99993H6.3077C6.21795 9.99993 6.14423 10.0288 6.08652 10.0865C6.02882 10.1442 5.99997 10.2179 5.99997 10.3076V19.6922C5.99997 19.7819 6.02882 19.8557 6.08652 19.9134C6.14423 19.9711 6.21795 19.9999 6.3077 19.9999ZM12 16.7499C12.4859 16.7499 12.899 16.5797 13.2394 16.2393C13.5798 15.899 13.75 15.4858 13.75 14.9999C13.75 14.514 13.5798 14.1009 13.2394 13.7605C12.899 13.4201 12.4859 13.2499 12 13.2499C11.5141 13.2499 11.1009 13.4201 10.7606 13.7605C10.4202 14.1009 10.25 14.514 10.25 14.9999C10.25 15.4858 10.4202 15.899 10.7606 16.2393C11.1009 16.5797 11.5141 16.7499 12 16.7499ZM8.99997 8.49995H15V6.49995C15 5.66662 14.7083 4.95828 14.125 4.37495C13.5416 3.79162 12.8333 3.49995 12 3.49995C11.1666 3.49995 10.4583 3.79162 9.87497 4.37495C9.29164 4.95828 8.99997 5.66662 8.99997 6.49995V8.49995Z",
    fill: "#677686"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockIcon);
export default __webpack_public_path__ + "static/media/lock-icon.83b11f684a9756ff05ee6c9bf99beeef.svg";
export { ForwardRef as ReactComponent };